export const SPACES = "/spaces";
export const SPACES_DETAILS = "/spaces/:spaceId";
export const SPACES_MESSAGE_PERMALINK = "/spaces/:spaceId/messages/:messageId";

export const SPACES_GUEST = "/spaces/guest";
export const SPACES_GUEST_DETAILS = "/spaces/guest/:spaceId";
export const SPACES_GUEST_LOGIN = "/spaces/guest/login";
export const SPACES_GUEST_LOGIN_EMAIL_SENT = "/spaces/guest/login/email-sent";
export const SPACES_GUEST_JOIN = "/spaces/guest/join";

export const SPACES_TASK_DETAILS = "/spaces/:spaceId/task/:taskId";
